"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../svg/index");

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _dropdown = require("./dropdown.style");

var _dropdown2 = _interopRequireDefault(require("./dropdown.components"));

var _svg = require("../../svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Dropdown = function Dropdown(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _dropdown.useStyles)(props);
  var content = props.content,
      select = props.select,
      filter = props.filter,
      selectPlaceholder = props.selectPlaceholder,
      filterPlaceholder = props.filterPlaceholder,
      onChange = props.onChange,
      size = props.size,
      invalidFeedback = props.invalidFeedback;

  var _useState = (0, _react.useState)(props.content["default"] ? [props.content["default"].name] : []),
      _useState2 = _slicedToArray(_useState, 2),
      selectText = _useState2[0],
      setSelectText = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      list = _useState4[0],
      setList = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showLoading = _useState6[0],
      setShowLoading = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 1),
      items = _useState8[0];

  var randomId = "".concat(new Date().getTime()).concat(Math.floor(Math.random() * 10000));
  var inputE = (0, _react.useRef)(null);
  var optionE = (0, _react.useRef)(null);
  var wrapperE = (0, _react.useRef)(null);

  var updateSelected = function updateSelected(selected, isChecked) {
    if (isChecked) {
      setSelectText(function (selectText) {
        return [].concat(_toConsumableArray(selectText), [selected.name]);
      });
    } else {
      setSelectText(selectText.filter(function (item) {
        return item !== selected.name;
      }));
    }
  };

  var selectItem = function selectItem(item) {
    setSelectText([item.name]);
    optionE.current.classList.remove(classes.block);
  };

  var open = function open() {
    if (optionE.current.classList.contains(classes.block)) {
      optionE.current.classList.remove(classes.block);
      setList(false);
    } else {
      optionE.current.classList.add(classes.block);
      setList(dropdown());
    }
  };

  var selectList = selectText.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(select ? classes.selectList : '', " ").concat(size === "sm" ? classes.selectListSm : size === "xs" ? classes.selectListXs : classes.selectListMd, " ").concat(props.disabled ? classes.disabled : null),
      key: index
    }, " ", item, " ");
  });

  var dropdown = function dropdown() {
    setShowLoading(true);
    return content.list.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_dropdown2["default"], {
        key: index,
        index: index,
        select: select,
        item: item,
        selectItem: selectItem,
        onChange: onChange,
        updateSelected: updateSelected,
        size: size,
        finishLoading: function finishLoading() {
          return setShowLoading(false);
        }
      });
    });
  };

  var filterFunction = function filterFunction() {
    var filter, counter, txtValue;
    filter = inputE.current.value;

    for (counter = 1; counter < optionE.current.children.length; counter++) {
      txtValue = optionE.current.children[counter].textContent;

      if (txtValue.indexOf(filter) > -1) {
        optionE.current.children[counter].style.display = "";
      } else {
        optionE.current.children[counter].style.display = "none";
      }
    }
  };

  (0, _react.useEffect)(function () {
    if (props.content["default"]) setSelectText([props.content["default"].name]);
  }, [props.content]); // update passed multi select array to outside of component

  (0, _react.useEffect)(function () {
    onChange(items);
  }, [items]);
  (0, _react.useEffect)(function () {
    if (list.length > 0) {
      setShowLoading(false);
    }
  }, [list]); // for closing tag when click outside of component

  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperE.current && !wrapperE.current.contains(event.target)) {
        optionE.current.classList.remove(classes.block);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperE]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.selectBox),
    id: randomId,
    ref: wrapperE
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "".concat(classes.selectBoxCurrent, " ").concat(classes[size], " ").concat(props.disabled ? classes.disabled : null),
    onClick: props.disabled ? null : open
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.selectBoxInputText)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(size === "sm" ? classes.itemsSizeSm : size === "xs" ? classes.itemsSizeXs : classes.itemsSizeMd, " ").concat(select ? '' : classes.singleSelectedLabel)
  }, selectPlaceholder), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(select ? classes.selectListItems : classes.singleSelectListItems)
  }, " ", selectList)), props.disabled ? null : /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.selectBoxIcon)
  }, _index.arrow)), /*#__PURE__*/_react["default"].createElement("ul", {
    ref: optionE,
    className: "".concat(classes.selectBoxList)
  }, filter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.selectBoxSearch)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputE,
    type: "text",
    className: "".concat(classes.selectBoxSearchInput),
    placeholder: filterPlaceholder,
    onKeyUp: filterFunction
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.selectBoxSearchIcon)
  }, _index.searchIcon)), showLoading ? /*#__PURE__*/_react["default"].createElement("div", null, _svg.ellipsis) : list), invalidFeedback && /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(classes.errColor, " ").concat(classes.invalidFeedback, "\n             ").concat(size === "sm" ? classes.errTxtSm : size === "xs" ? classes.errTxtXs : classes.errTxtMd)
  }, invalidFeedback));
};

exports.Dropdown = Dropdown;
Dropdown.propTypes = {
  /** Can filtering item */
  filter: _propTypes["default"].bool,

  /** Set placeholder to filter input */
  filterPlaceholder: _propTypes["default"].string,

  /** Can multi select item */
  select: _propTypes["default"].bool,

  /** Set placeholder to select component */
  selectPlaceholder: _propTypes["default"].string,

  /** get items to show select list */
  content: _propTypes["default"].object,

  /** Send selected items to component outside */
  onchange: _propTypes["default"].func,

  /** component size */
  size: _propTypes["default"].oneOf(["md", "sm"]),

  /** Show loading */
  loading: _propTypes["default"].bool,

  /** Show loading */
  invalidFeedback: _propTypes["default"].string
};
Dropdown.defaultProps = {
  filter: false,
  select: false,
  filterPlaceholder: "جستجو",
  selectPlaceholder: "انتخاب کنید",
  size: "md",
  loading: false,
  invalidFeedback: null
};